<template>
    <ul class="social-icons flex">
        <li class="social-icon__wrapper">
            <a
                :href="
                    `${$getState(
                        'appUrl'
                    )}/sociallogin/login/twitter?hash=${$getState(
                        'hash'
                    )}&referral=${$getState('referral')}`
                "
                class="social-icon flex justify-center items-center"
            >
                <Social icon="twitter"></Social>
            </a>
        </li>
        <li class="social-icon__wrapper">
            <button
                v-if="showFacebookBtn"
                type="button"
                class="social-icon flex justify-center items-center"
                @click="logInWithFacebook"
            >
                <Social icon="facebook"></Social>
            </button>
        </li>
        <li class="social-icon__wrapper">
            <a
                :href="
                    `${$getState(
                        'appUrl'
                    )}/sociallogin/login/google?hash=${$getState(
                        'hash'
                    )}&referral=${$getState('referral')}`
                "
                class="social-icon flex justify-center items-center"
            >
                <Social icon="google"></Social>
            </a>
        </li>
        <li class="social-icon__wrapper">
            <a
                :href="
                    `${$getState(
                        'appUrl'
                    )}/sociallogin/login/apple?hash=${$getState(
                        'hash'
                    )}&referral=${$getState('referral')}`
                "
                class="social-icon flex justify-center items-center"
            >
                <Social icon="apple"></Social>
            </a>
        </li>
    </ul>
</template>

<script>
import Social from "../Icons/Social";
import store from "../../config/store";
import Vue from "vue";

export default {
    name: "SocialLogin",

    components: {
        Social
    },

    props: ["clickHandler"],

    data: function() {
        return {
            showFacebookBtn: true
        };
    },

    methods: {
        logInWithFacebook: function() {
            if (window.FB === undefined) {
                this.loadFacebookSDK(document, "script", "facebook-jssdk");
                this.initFacebook();
            } else {
                try {
                    this.facebookLogin();
                } catch (e) {
                    this.initFacebook();
                }
            }
            return false;
        },
        facebookLogin: function() {
            const self = this;
            window.FB.login(function(response) {
                if (response.authResponse) {
                    window.FB.api(
                        "/me",
                        "GET",
                        { fields: "id, name, email" },
                        function(response) {
                            self.socialAuth("facebook", response);
                        }
                    );
                } else {
                    console.log(
                        "User cancelled login or did not fully authorize."
                    );
                }
            });
        },
        initFacebook: function() {
            const appId = this.$store.state.fbAppID;
            const self = this;
            window.fbAsyncInit = function() {
                window.FB.init({
                    appId: appId, //You will need to change this
                    cookie: true, // This is important, it's not enabled by default
                    version: "v11.0"
                });

                window.FB.getLoginStatus(function(response) {
                    self.facebookLogin();
                });
            };
        },
        loadFacebookSDK: function(d, s, id) {
            let js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        },
        socialAuth: function(provider, params) {
            params.hash = this.$getState("hash");
            params.referral = this.$getState("referral");
            this.$http
                .post(`user/socialauth/${provider}`, params)
                .then(data => {
                    this.$setState(
                        "user",
                        !data.data.user || !data.data.user.id
                            ? false
                            : data.data.user
                    );
                    this.$setState(
                        "appUrl",
                        !data.data.app_url ? "" : data.data.app_url
                    );
                    if (data.data.token) {
                        this.$http.defaults.headers["Authorization"] =
                            "Bearer " + data.data.token;
                        this.$token.value = data.data.token;
                        this.$setLocalStorage(
                            "thriveAppToken",
                            data.data.token
                        );
                        this.$setLocalStorage("thriveAppTokenRemember", true);
                        this.$setLocalStorage(
                            "thriveAppTokenInitTime",
                            +new Date()
                        );
                    }

                    if (
                        data.data.is_corporation !== undefined &&
                        data.data.is_corporation
                    ) {
                        if (data.data.corporation !== undefined) {
                            const corp = data.data.corporation;
                            corp.is = true;
                            store.commit("corporation", corp);
                            store.commit(
                                "theme",
                                data.data.corporation.color_input
                            );
                        }
                    }

                    this.$setState(
                        "fbAppID",
                        !data.data.config.fb_app_id
                            ? ""
                            : data.data.config.fb_app_id
                    );

                    this.$store.commit(
                        "stripeKey",
                        !data.data.config.stripe_key
                            ? ""
                            : data.data.config.stripe_key
                    );

                    if (this.$store.state.user.id !== undefined) {
                        if (
                            // this.$getLocalStorage(
                            //     "ThriveAppLoginProcessType",
                            // ) === "signIn"
                            this.$getState("loginOperation") === "signIn"
                        ) {
                            this.$router.push("/dashboard");
                        } else {
                            if (this.$user("has_avatar") === 1) {
                                this.$setState("loginActiveStep", "cause");
                                this.$setState("loginSteps", { signUp: true });
                            } else {
                                this.$setState("startSign", false);
                            }
                        }
                    }
                });
        }
    }
};
</script>
